import React from "react";

export default function PacifierPicture(props) {
    return (
        <div className="d-flex align-items-center justify-content-center ">
            <div
                className="text-white d-flex align-items-center justify-content-center"
                style={{
                    width: "150",
                    height: "150",
                    backgroundColor: "rgba(0,0,0,0.3)",
                }}
            >
                <p>thumbnail</p>
            </div>
        </div>
    );
}
